<template>
	<b-modal
		ref="change-specimen-color-modal"
		:title="`Migrar ejemplares del color ${color.color}`"
		no-close-on-backdrop
		centered
		@hidden="handleHidden"
		size="md"
		@ok.prevent="migrateSpecimens"
		ok-title="Migrar"
		:ok-disabled="!selectedColor"
	>
		<b-form-group label="Color">
			<v-select
				v-model="selectedColor"
				label="color"
				:options="colors"
				placeholder="Seleccione un color"
				class="w-100"
				:clearable="false"
			/>
		</b-form-group>
	</b-modal>
</template>

<script>
import SpecimenPlate from "@/components/specimens/SpecimenPlate.vue"
import SpecimenColorService from "@/views/brain/specimens/views/colors/services/color.service.js"
export default {
	components: { SpecimenPlate },
	props: {
		color: Object,
	},
	data() {
		return {
			isLoading: false,
			colors: [],
			selectedColor: null,
		}
	},
	computed: {},
	methods: {
		async refresh() {
			await this.getDetails()
		},
		handleHidden() {
			this.isLoading = false
			this.$emit("close")
		},
		async getDetails(page = 1) {
			this.isPreloading()
			try {
				const { data } = await SpecimenColorService.getColorsToSelect()
				this.colors = data.filter((color) => color.id !== this.color.id)
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
		async migrateSpecimens() {
			const { isConfirmed } = await this.showConfirmSwal({
				text: `Se cambiaran ${this.color.specimen_counter} ejemplares del color ${this.color.color} al color ${this.selectedColor.color}`,
			})
			if (!isConfirmed) return
			this.isPreloading()
			try {
				await SpecimenColorService.changeSpecimensColor({
					color_from: this.color.id,
					color_to: this.selectedColor.id,
				})
				this.$emit("refresh")
				this.$emit("close")
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
	},
	async mounted() {
		await this.getDetails()
		this.$refs["change-specimen-color-modal"].toggle()
	},
}
</script>

<style></style>
